// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../bos/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../bos/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.k-pivotgrid-row-headers table.k-pivotgrid-table {
  table-layout: auto;
}

.k-pivotgrid-column-headers col,
.k-pivotgrid-values col {
  width: 150px;
}`, "",{"version":3,"sources":["webpack://./../gui/src/public/css/pivotGrid.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;AACJ;;AAEA;;EAEI,YAAA;AACJ","sourcesContent":[".k-pivotgrid-row-headers table.k-pivotgrid-table {\n    table-layout: auto;\n}\n\n.k-pivotgrid-column-headers col,\n.k-pivotgrid-values col {\n    width: 150px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
